import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Component } from 'react';
import { Element } from 'react-scroll';
import { CAREER_MONTH_DEFAULT_VALUE, CAREER_YEAR_DEFAULT_VALUE, } from '../../../define/consts/profile';
import { propBool, propFuncList, propShape, propStr, } from '../../../helpers/custom-prop-types';
import { getFormErrorsFirst } from '../../../helpers/form';
import InputError from '../Common/InputError';
import CareerFieldsAndLabelComponent from './CareerFieldsAndLabelComponent';
class CareerFieldsAndLabel extends Component {
    constructor() {
        super(...arguments);
        this.onClickDelete = (e) => {
            const index = parseInt(e.currentTarget.value, 10);
            const { fields } = this.props;
            fields.remove(index);
            if (fields.length === 1) {
                this.onClickPush();
            }
        };
        this.onClickPush = () => {
            const { fields } = this.props;
            fields.push({
                month: CAREER_MONTH_DEFAULT_VALUE,
                year: CAREER_YEAR_DEFAULT_VALUE,
            });
        };
    }
    render() {
        const { contentPlaceholder, contentValidate, dateAnnotation, fields, hasPosition, heading, isRequired, positionPlaceholder, positionValidate, thisForm, titlePlaceholder, titleValidate, } = this.props;
        const globalError = getFormErrorsFirst(thisForm, [`${fields.name}._error`], !thisForm.submitFailed);
        return (_jsxs("div", Object.assign({ className: `form form-solution ${isRequired ? 'req' : ''}` }, { children: [_jsx(Element, { name: fields.name }), _jsx("h3", { children: heading }), fields.map((field, index) => (_jsx(CareerFieldsAndLabelComponent, { contentPlaceholder: contentPlaceholder, contentValidate: contentValidate, dateAnnotation: dateAnnotation, field: field, hasPosition: hasPosition, index: index, onClickDelete: this.onClickDelete, positionPlaceholder: positionPlaceholder, positionValidate: positionValidate, titlePlaceholder: titlePlaceholder, titleValidate: titleValidate }, field))), _jsx("button", Object.assign({ className: 'btn btn-default small wide', onClick: this.onClickPush, type: 'button' }, { children: "\u8FFD\u52A0\u3059\u308B" })), _jsx(InputError, { className: 'mt1', error: globalError })] })));
    }
}
CareerFieldsAndLabel.propTypes = {
    contentPlaceholder: propStr().isRequired,
    contentValidate: propFuncList().isRequired,
    dateAnnotation: propStr(),
    fields: propShape().isRequired,
    hasPosition: propBool(),
    heading: propStr().isRequired,
    isRequired: propBool().isRequired,
    positionPlaceholder: propStr(),
    positionValidate: propFuncList(),
    thisForm: propShape().isRequired,
    titlePlaceholder: propStr().isRequired,
    titleValidate: propFuncList().isRequired,
};
CareerFieldsAndLabel.defaultProps = {
    dateAnnotation: '',
    hasPosition: false,
    positionPlaceholder: '',
    positionValidate: [],
};
export default CareerFieldsAndLabel;
